import { NgModule } from '@angular/core';
import { OfflineToolbarComponent } from '@app/shared/offline-toolbar/offline-toolbar.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmModule } from '@app/shared/confirm/confirm.module';

@NgModule({
  declarations: [OfflineToolbarComponent],
  imports: [CommonModule, MatButtonModule, TranslateModule, MatDialogModule, MatIconModule, ConfirmModule],
  exports: [OfflineToolbarComponent],
})
export class OfflineToolbarModule {}
